import UploadModal from './UploadModal';
import NewVersionModal from './NewVersionModal';

export default UploadModal;
export { NewVersionModal };
